define('components/hotspot/models/hotspot',[], function() {
    "use strict";

    var HotspotModelClass = Backbone.Model.extend({
        "defaults": function() {
            return {

                /* Holds the type of hotspot i.e. image/text/circle
                 *
                 * @property type
                 * @type {String}
                 * @default null
                 */
                "type": null,

                /* This property holds state for hotspot i.e. selected/active/visited
                 *
                 * @property state
                 * @type {String}
                 * @default null
                 */
                "state": null,

                /* This property holds hight and width of hotspot container
                 *
                 * @property bounds
                 * @type {Object}
                 * @default object
                 */
                "bounds": {
                    "top": null,
                    "left": null,
                    "width": null,
                    "height": null
                },
                /* This property holds tooltip data
                 *
                 * @property tooltips
                 * @type {Object}
                 * @default null
                 */
                "tooltips": null,

                /* This property holds url for background-image of
                 *
                 * @property url
                 * @type {String}
                 * @default null
                 */
                "url": null,

                /* This property holds content if mode is text
                 *
                 * @property content
                 * @type {String}
                 * @default null
                 */
                "content": null,

                /* This property holds html for tooltips of hotspot
                 *
                 * @property tooltipHtmlArray
                 * @type {Array}
                 * @default null
                 */
                "tooltipHtmlArray": null,

                /**
                 * This property holds the number of tooltips that have been displayed
                 *
                 * @property numberOfVisitedToolips
                 * @type {Number}
                 * @default 0
                 */
                "numberOfVisitedToolips": 0,

                "totalNumberOfTooltips": null,

                "isHotspotVisited": false,
                "currentSelectedBlockIndex": null,
                "tooltipModelArray": null,
                "visitedTooltipsIndexArray": [],
                "currentParagraphTooltipIndex": null
            };
        },
        /**
         * initialize the click and reveal model and set the default values.
         *
         * @method initialize
         */
        "initialize": function() {
            var numberOfTooltips = this.get("totalNumberOfTooltips") || this.get("tooltips").length;
            this.set("totalNumberOfTooltips", numberOfTooltips);
            this.listenTo(this, "change:isHotspotVisited", this._updateHotspotState);
        },

        "_updateHotspotState": function() {
            if (this.get("isHotspotVisited")) {
                this.set("state", HotspotModelClass.STATES.COMPLETE);
                this.trigger(HotspotModelClass.EVENTS.HOTSPOT_VISITED);
            }
        }

    }, {

        "STATES": {

            "VISITED": 0,
            "ACTIVE": 1,
            "SELECTED": 2,
            "COMPLETE": 3,
            "INCOMPLETE": 4
        },
        "TYPES": {
            "BASE_HOTSPOT": 0,
            "POINT_HOTSPOT": 1,
            "TEXT_HOTSPOT": 2,
            "IMAGE_HOTSPOT": 3,
            "PARAGRAPH_HOTSPOT": 4
        },

        "EVENTS": {
            "HOTSPOT_VISITED": "hotspot-visited"
        }

    });
    return HotspotModelClass;
});

